// extracted by mini-css-extract-plugin
export var equalColumn = "_h2-0";